export default function AavaaHubVisual() {
  return (
    <div className="w-full flex items-center justify-center py-4" data-testid="aavaa-hub-visual">
      <svg
        viewBox="0 0 320 240"
        className="w-full max-w-[280px] h-auto"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* Soft ambient glow under device */}
          <radialGradient id="hub-floor-shadow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#2F3630" stopOpacity="0.18" />
            <stop offset="70%" stopColor="#2F3630" stopOpacity="0.04" />
            <stop offset="100%" stopColor="#2F3630" stopOpacity="0" />
          </radialGradient>

          {/* Body cream gradient — subtle top highlight */}
          <linearGradient id="hub-body" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#FDFBF6" />
            <stop offset="55%" stopColor="#F3EFE6" />
            <stop offset="100%" stopColor="#E8E2D3" />
          </linearGradient>

          {/* Top surface gloss */}
          <linearGradient id="hub-top-gloss" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
          </linearGradient>

          {/* Sage LED ring glow */}
          <radialGradient id="led-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#8E9B82" stopOpacity="0.9" />
            <stop offset="60%" stopColor="#8E9B82" stopOpacity="0.35" />
            <stop offset="100%" stopColor="#8E9B82" stopOpacity="0" />
          </radialGradient>

          {/* Inner ring highlight */}
          <radialGradient id="led-core" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#A7B399" />
            <stop offset="100%" stopColor="#7A8A6E" />
          </radialGradient>

          {/* Ambient light halo behind whole device */}
          <radialGradient id="ambient-halo" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#D4A373" stopOpacity="0.12" />
            <stop offset="100%" stopColor="#D4A373" stopOpacity="0" />
          </radialGradient>
        </defs>

        {/* Ambient warm halo */}
        <ellipse cx="160" cy="120" rx="150" ry="110" fill="url(#ambient-halo)" />

        {/* Floor shadow */}
        <ellipse cx="160" cy="210" rx="95" ry="11" fill="url(#hub-floor-shadow)" />

        {/* Device body — rounded pebble shape, slight 3/4 perspective */}
        <g>
          {/* Main body */}
          <path
            d="M 80 95
               Q 80 65 115 65
               L 205 65
               Q 240 65 240 95
               L 240 175
               Q 240 200 210 200
               L 110 200
               Q 80 200 80 175
               Z"
            fill="url(#hub-body)"
            stroke="#D9D2C2"
            strokeWidth="0.75"
          />

          {/* Top highlight band */}
          <path
            d="M 90 75
               Q 90 72 95 72
               L 225 72
               Q 230 72 230 75
               L 230 90
               Q 160 100 90 90
               Z"
            fill="url(#hub-top-gloss)"
            opacity="0.5"
          />

          {/* Subtle vertical seam (design detail) */}
          <line x1="160" y1="192" x2="160" y2="196" stroke="#C9C0AD" strokeWidth="0.5" opacity="0.5" />
        </g>

        {/* LED glow halo (larger, soft) — subtle pulse */}
        <circle cx="160" cy="130" r="52" fill="url(#led-glow)">
          <animate attributeName="r" values="48;56;48" dur="3.2s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.75;1;0.75" dur="3.2s" repeatCount="indefinite" />
        </circle>

        {/* LED outer ring */}
        <circle cx="160" cy="130" r="32" fill="none" stroke="#8E9B82" strokeWidth="3.5" opacity="0.95" />

        {/* LED inner disc */}
        <circle cx="160" cy="130" r="27" fill="url(#led-core)" />

        {/* LED specular highlight */}
        <ellipse cx="152" cy="122" rx="9" ry="5" fill="#FFFFFF" opacity="0.35" />

        {/* aavaa wordmark below LED */}
        <text
          x="160"
          y="180"
          textAnchor="middle"
          fill="#6B7264"
          fontFamily="'Outfit', sans-serif"
          fontSize="11"
          fontWeight="500"
          letterSpacing="1.5"
          opacity="0.6"
        >
          aavaa
        </text>

        {/* USB-C cable peek behind device */}
        <g opacity="0.65">
          <rect x="236" y="150" width="14" height="8" rx="2" fill="#B8AE98" />
          <path
            d="M 250 154
               Q 272 154 275 170
               Q 278 188 290 205"
            fill="none"
            stroke="#B8AE98"
            strokeWidth="3.5"
            strokeLinecap="round"
          />
        </g>
      </svg>
    </div>
  );
}
